
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gXILZeHdBKDGh4m6Jsf1gjbK0Tzt9d9ubHZDpQoqavTUMeta } from "/codebuild/output/src3754250104/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexPTU0V9kiq0RI0ZGbwdPf7ivEpJtv_5IDyIFTHCT_CJIMeta } from "/codebuild/output/src3754250104/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchMyz_gRhCvL3aVFWarb8hu7Dnhwdkaym1heSEgmc0eewMeta } from "/codebuild/output/src3754250104/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexTuLGZzkmpggwh7BZEy5eybiifAcdCGRZeAzSj6guQPMMeta } from "/codebuild/output/src3754250104/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_930OB_45HeHjXWjkRWG8ZQFQQEMHUMOghA_45t_456Eqyp7x_YwMeta } from "/codebuild/output/src3754250104/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexI9tPDFtVrNx5HY9vP_454x_dcZbezrC_UFiVqos_Q8XkoMeta } from "/codebuild/output/src3754250104/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93qjDJljtoXfrs2TI7LZJOitJe3Vck8zG5YBUSFE8RyigMeta } from "/codebuild/output/src3754250104/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexNArNDYxni9UITjQxn6l6OCxQASRz2SNTuRZ9NwVELjUMeta } from "/codebuild/output/src3754250104/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93wWRzHsvRgdgD4Oqb09_45sDZEt7zi4eDV1lQlonWad8kUMeta } from "/codebuild/output/src3754250104/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexD9LbB5dCZ8t1iizQt0B3qp8Vt6qeb9a60IXErfUHeDYMeta } from "/codebuild/output/src3754250104/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexUqDqTyf0iWG6IbwvYBGlJBRrb5kg_45wgxGjhVOU3KCnQMeta } from "/codebuild/output/src3754250104/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src3754250104/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3754250104/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src3754250104/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src3754250104/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src3754250104/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexI9tPDFtVrNx5HY9vP_454x_dcZbezrC_UFiVqos_Q8XkoMeta || {},
    component: () => import("/codebuild/output/src3754250104/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src3754250104/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexNArNDYxni9UITjQxn6l6OCxQASRz2SNTuRZ9NwVELjUMeta || {},
    component: () => import("/codebuild/output/src3754250104/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src3754250104/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexD9LbB5dCZ8t1iizQt0B3qp8Vt6qeb9a60IXErfUHeDYMeta || {},
    component: () => import("/codebuild/output/src3754250104/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexUqDqTyf0iWG6IbwvYBGlJBRrb5kg_45wgxGjhVOU3KCnQMeta || {},
    component: () => import("/codebuild/output/src3754250104/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]